import { render, staticRenderFns } from "./modal-game-information.vue?vue&type=template&id=3faea124&scoped=true"
import script from "./modal-game-information.vue?vue&type=script&lang=js"
export * from "./modal-game-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faea124",
  null
  
)

export default component.exports